import * as types from "./types";

const mutations = {
	// Модалка. Уведомления (Колокольчик)
	[types.MODAL_NOTIFY](state: { modalNotify: object }, modalNotify: object) {
		state.modalNotify = modalNotify;
	},

	// Модалка. Профиль
	[types.MODAL_PROFILE](state: { modalProfile: object }, modalProfile: object) {
		state.modalProfile = modalProfile;
	},

	// Модалка с фильтрами для мобильных устройств
	[types.MODAL_MOBILE_FILTERS](
		state: { modalMobileFilters: object },
		modalMobileFilters: object
	) {
		state.modalMobileFilters = modalMobileFilters;
	},

	// Модалка - Активировать канал
	[types.MODAL_ACTIVATE_CHANNEL](
		state: { modalActivateChannel: object },
		modalActivateChannel: object
	) {
		state.modalActivateChannel = modalActivateChannel;
	},

	// Тип устройства (desktop or mobile)
	[types.DEVICE_TYPE](state: { device: object }, device: object) {
		state.device = device;
	},

	// Список инстансов
	[types.INSTANCES](state: { instances: object }, instances: object) {
		state.instances = instances;
	},

	// Подробная информация об инстансе
	[types.INSTANCE](
		state: { instance: object | null },
		instance: object | null
	) {
		state.instance = instance;
	},

	/**
	 * Сохраняет переданное состояние загрузки карточки, не изменяя данные инстанса.
	 */
	[types.INSTANCE_LOAD_STATUS](
		state: { instanceLoadStatus: types.InstanceLoadStatus },
		status: types.InstanceLoadStatus
	) {
		state.instanceLoadStatus = status;
	},

	// Создание инстанса
	[types.INSTANCE_CREATE](
		state: { instanceCreateState: object },
		instanceCreateState: object
	) {
		state.instanceCreateState = instanceCreateState;
	},

	// Переход на другую страницу
	[types.REDIRECT](state: { redirectState: object }, redirectState: object) {
		state.redirectState = redirectState;
	},

	// Удаляем инстанс
	[types.INSTANCE_DELETE](
		state: { instanceDeleteState: object },
		instanceDeleteState: object
	) {
		state.instanceDeleteState = instanceDeleteState;
	},

	// Модалка. Получить QR код
	[types.MODAL_QR_CODE](
		state: { modalQrCodeState: object },
		modalQrCodeState: object
	) {
		state.modalQrCodeState = modalQrCodeState;
	},

	// Получить QR код
	[types.QR_CODE](state: { qrCodeState: object }, qrCodeState: object) {
		state.qrCodeState = qrCodeState;
	},

	// Перезагружаем инстанс
	[types.INSTANCE_REBOOT](
		state: { instanceRebootState: object },
		instanceRebootState: object
	) {
		state.instanceRebootState = instanceRebootState;
	},

	// Logout instance
	[types.INSTANCE_LOGOUT](
		state: { instanceLogoutState: object },
		instanceLogoutState: object
	) {
		state.instanceLogoutState = instanceLogoutState;
	},

	// Сохраняем настройки
	[types.INSTANCE_SET_SETTINGS](
		state: { instanceSetSettingsState: object },
		instanceSetSettingsState: object
	) {
		state.instanceSetSettingsState = instanceSetSettingsState;
	},

	// Модалка. Лог действий
	[types.MODAL_EVENT_LOG](
		state: { modalEventLogState: object },
		modalEventLogState: object
	) {
		state.modalEventLogState = modalEventLogState;
	},

	// Лог действий
	[types.EVENT_LOG](state: { eventLogState: object }, eventLogState: object) {
		state.eventLogState = eventLogState;
	},

	// Лог действий. Запись события
	[types.SEND_EVENT_LOG](
		state: { sendEventLogState: object },
		sendEventLogState: object
	) {
		state.sendEventLogState = sendEventLogState;
	},

	// Список опций для покупок
	[types.OPTION_LIST](state: { optionListState: [] }, optionListState: []) {
		state.optionListState = optionListState;
	},
};

export default mutations;
